import { apolloClient } from '@/lib/apolloClient';
import {
  SaveSitePage,
  SaveSitePageMutationData,
  SaveSitePageMutationVariables,
} from '@/mutations/SaveSitePage';
import {
  UpdateStyles,
  UpdateStylesMutationResult,
  UpdateStylesMutationVariables,
} from '@/mutations/UpdateStyles';
import { DraftSection } from '@/types/DraftSection';
import { GlobalStyles } from '@/types/GlobalStyles';

// The purpose of this service is to make client-side graph calls from outside React components such as the previewHelper util that do not have access to React hooks
const updateGlobalStyles = (
  globalStyles: GlobalStyles,
  presetName?: string
) => {
  return apolloClient.mutate<
    UpdateStylesMutationResult,
    UpdateStylesMutationVariables
  >({
    mutation: UpdateStyles,
    fetchPolicy: 'no-cache',

    variables: {
      input: {
        styles: globalStyles,
        presetName,
      },
    },
    context: {
      clientName: 'public',
    },
  });
};

const saveSitePage = (
  sitePageId: string,
  sectionAttributes: DraftSection[],
  publish = false
) => {
  return apolloClient.mutate<
    SaveSitePageMutationData,
    SaveSitePageMutationVariables
  >({
    mutation: SaveSitePage,
    fetchPolicy: 'no-cache',

    variables: {
      input: {
        sitePageId,
        sectionAttributes,
        publish,
      },
    },
    context: {
      clientName: 'public',
    },
  });
};

// Export as a service instead of individual functions so that we can properly mock them in Jest tests
const clientSideApiService = {
  saveSitePage,
  updateGlobalStyles,
};

export default clientSideApiService;
